import { Component, HostBinding, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Exercise } from '@digilize/language-school/definitions';
import { ExercisesService } from '@digilize/language-school/feature/exercises';

@Component({
  selector: 'lsc-exercise-list',
  templateUrl: './exercise-list.component.html',
  styleUrls: ['./exercise-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExerciseListComponent implements OnInit {
  @Input() standalone = false; /* not standalone means within wrapper - most likely accordion*/
  @Input() exercises: Exercise[];
  @Input() lessonId: string;
  @Input() withCheckboxes = true;
  @HostBinding('class') class;

  constructor(private exercisesService: ExercisesService) {}

  ngOnInit() {
    this.class += this.standalone ? ' standalone' : ' not-standalone';
  }

  handleStartExercise(exercise: Exercise) {
    this.exercisesService.play(exercise, this.lessonId, true);
  }
}
